module.exports = __webpack_public_path__ + "static/media/readyToShoot.ad76ae89.mp3";